import React, { useCallback } from 'react';

import Micromag from '../partials/Micromag';
import Button from '../buttons/Button';
import Cookie from '../icons/Cookie';
import ConsentModal from '../modals/Consent';
import styles from '../../styles/pages/home.module.css';
import { useModal } from '../../contexts/ModalContext';

interface HomePageProps {
    micromag?: Record<string, any> | null;
    disabled?: boolean;
}

function HomePage({ micromag = null, disabled = false }: HomePageProps) {
    const { modal = null, setModal = null } = useModal();
    const onClickCookie = useCallback(() => {
        if (setModal !== null) {
            setModal('consent');
        }
    }, [setModal]);

    return (
        <div className={styles.container}>
            {disabled ? (
                <div className={styles.centered}>
                    <h3 className={styles.title}>Bientôt disponible!</h3>
                </div>
            ) : (
                <Micromag micromag={micromag} className={styles.micromag} />
            )}
            {modal === 'consent' ? (
                <ConsentModal className={styles.consentModal} />
            ) : (
                <Button className={styles.cookies} onClick={onClickCookie}>
                    <Cookie className={styles.cookieIcon} />
                </Button>
            )}
        </div>
    );
}

export default HomePage;
